import React from "react";
import { Box } from "@mui/material";
import { ModelAttributes } from "src/components/Home/types";
import { useStyles } from "./styles";

type Data = {
  data: ModelAttributes[];
};

const ProfileTable: React.FC<Data> = ({ data }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      {data.map((el, index) => (
        <Box key={index} className={classes.row}>
          <Box className={classes.label}>{el.name}</Box>
          <Box className={classes.value}>{el.value}</Box>
        </Box>
      ))}
    </Box>
  );
};

export { ProfileTable };
